

import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';


const TodayAppointmentsforclinic = () => {

  const [showActionsMenu, setShowActionsMenu] = useState(null);
  const handleActionsClick = (index) => {
    setShowActionsMenu(showActionsMenu === index ? null : index);
  };
  return (
   <div className="appointments-table-container">
       <table className="user-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Image</th>
            <th>Client Name</th>
            <th>Provider</th>
            <th>Payment Mode</th>
            <th>Appointment Status</th>
            <th>Date & Time</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {/* {appointmentsData.map((appointment,index) => (
            <tr key={appointment.id}>
              <td>{appointment.id}</td>
              <td><img src={appointment.image} alt="Client" className="client-image" /></td>
              <td>{appointment.clientName}</td>
              <td>{appointment.provider}</td>
              <td>{appointment.paymentMode}</td>
              <td>{appointment.appointmentStatus}</td>
              <td>{appointment.dateTime}</td>
              <td><button className="view-button" onClick={() => handleActionsClick(index)}>View</button>
              {showActionsMenu === index && (
                  <div className="user-table-popup-menu">
                    <ul>
                      <li onClick={()=>navigate('/ClientDetails')}>View Info.</li>
                      <li>Message</li>
                      <li>History</li>
                    </ul>
                  </div>
                )}
              </td>
            </tr>
          ))} */}
        
        </tbody>
      </table>
      <div style={{marginTop:20,textAlign:'center',width:'100%'}}> No Appointment Today</div>
    </div> 
  )
}

export default TodayAppointmentsforclinic